export const FieldErrorTestIdFactory = {
    getFieldErrorBase: () => `field-error`,
    getFieldErrorListItemTestId: (testId) => [FieldErrorTestIdFactory.getFieldErrorBase(), testId].join('-'),
};
